/*!
 * Backbone.js ajaxRetry
 * https://github.com/gdibble/backbone-ajaxretry
 * Copyright 2014 Gabriel Dibble; Licensed MIT
 * Modified by Jacob Mainzer 12/12/2014
 * Modified by Matthew Schwickerath 2020-06-26
 */
define(['backboneBase', 'underscore', 'jquery'], function(Backbone, _, $){


var _$ajax, settings;

settings = { //Defaults that can be overridden via set
  base:           2.718281828,
  y:              0.25,
  retryCount:     2,
  onlyBackbone:   false,
  // Optional function that will be called if the server returns a 401
  reauthenticate: null
};

//-----------------------------------------------------------------------------


// Helpers:
//  some console.logs have been left (as to be enabled) for those curious minds


//Update current settings, overriding defaults
function setOptions(options) {
  _.defaults(options, settings);
  settings = options;
}

//delay in milliseconds
function exponentialDelay(x) {
  return (Math.pow(settings.base, x) - settings.y) * 1000;
}

//Called when we have run out of retries.  The function just calls the original error function passed to ajax, as if we never did any retries.
function exhaust(jqXHR, textStatus, errorThrown) {
  if (window._LTracker) {
    if (errorThrown) {
      window._LTracker.track(errorThrown);
    } else if (textStatus == "error") {
      window._LTracker.track({
        error: "XMLHTTPRequest error",
        url: jqXHR.url,
        type: jqXHR.type,
        status: jqXHR.status,
        response: jqXHR.responseText
      });
    }
  }
  jqXHR.origError.apply(this, arguments);
}

//hit retry limit
function exhausted() {
  var args;

  args = Array.prototype.slice.call(arguments, 0);

  _.extend(args[0], this);
  // console.log('exhausted', this.url);
    // console.log('>>> called this.exhaust', this.exhaust);
  exhaust.apply(this, args);
}



//recurse the ajax request
function ajaxRetry(jqXHR) {
  var self;
  var originalArguments = Array.prototype.slice.call(arguments, 0);

  self = this;
  // eslint-disable-next-line no-prototype-builtins
  if (!this.hasOwnProperty('retries')) {
    exhausted.apply(self, originalArguments);
    return;
  }
  this.recursed = this.recursed === undefined ? 0 : this.recursed + 1;
  if (this.recursed >= this.retries) {
    exhausted.apply(self, originalArguments);
    return;
  }
  var status = jqXHR ? jqXHR.status : 0;
  // Allow retrying 401 Not Authorized if a reauthenticate function was supplied
  if (status == 401) {
    if (!settings.reauthenticate) {
      exhausted.apply(self, originalArguments);
    } else {
      settings.reauthenticate()
        .done(function () {
          $.ajax(self);
        })
        .fail(function () {
          exhausted.apply(self, originalArguments);
        });
    }
    return;
  }
  //Retry for HTTP 500 requests or browser failures (status of 0)
  //Do not retry for POST, PUT or DELETE because it is possible that despite the error the
  //item succeeded, and trying to do it again might result in duplicate records or an invalid state
  if ((status > 0 && status < 500) || self.type !== "GET") {
    exhausted.apply(self, originalArguments);
    return;
  }
  console.log("AJAX retry");
  setTimeout(function () {
    $.ajax(self);
     //console.log('recursed', self.url, self.recursed, 'in ' + exponentialDelay(self.recursed) + 'ms');
  }, exponentialDelay(this.recursed));
}

function extender(args, options) {
  _.extend(args[0], options && typeof options === 'object' ? options : {}, {
    retries: settings.retryCount,
    error:   function () { ajaxRetry.apply(this, arguments); }
    }, 
    typeof options.origError === 'undefined' ? {origError: options.error} : {} //store the original error function in origError, but only before we do any retries since the error function gets overriden
  );
}

function sliceArguments() {
  return Array.prototype.slice.call(arguments, 0);
}

//-----------------------------------------------------------------------------


//extend for retry functionality:
if (!settings.onlyBackbone) {
  //retry regular $.ajax thus also Backbone ajax requests
  _$ajax = $.ajax;
  $.ajax = function (options) {
    var args;

    if (typeof options === 'string') {
      arguments[1].url = options; //in this case, options is actually the url passed to $.get/$.post
      args = sliceArguments(arguments[1]);
      extender(args, options);
    } else {
      args = sliceArguments(arguments);
      extender(args, options);
    }

    return _$ajax.apply($, args);
  };
} else {
  //retry only Backbone ajax requests
  Backbone.ajax = function (options) {
    var args;

    args = sliceArguments(arguments);
    extender(args, options);

    // noinspection JSUnresolvedVariable
    return Backbone.$.ajax.apply(Backbone.$, args);
  };
}

  return { set: setOptions };

});
